import { render, staticRenderFns } from "./qaRecord.vue?vue&type=template&id=8d43c836&scoped=true&"
import script from "./qaRecord.vue?vue&type=script&lang=js&"
export * from "./qaRecord.vue?vue&type=script&lang=js&"
import style0 from "./qaRecord.vue?vue&type=style&index=0&id=8d43c836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d43c836",
  null
  
)

export default component.exports